<div @fadeIn @fadeOut class="bg-red-50 border border-red-400 rounded-md flex items-center text-warn ps-4 pe-1 py-1">
    <mat-icon svgIcon="heroicons_solid:x-circle" class="text-warn scale-75 mr-2"></mat-icon>
    <p class="flex-grow">{{ fullErrorMessage() }}</p>
    <button mat-icon-button (click)="onDismiss.emit()">
        <mat-icon svgIcon="heroicons_outline:x-mark" class="size-4 scale-75 text-warn"></mat-icon>
    </button>
</div>
